import { configureStore } from '@reduxjs/toolkit';
import authReducer from './state/authSlice';
import parkingReducer from './state/parkingSlice';
import bookingReducer from './state/bookingSlice';
import userReducer from './state/userSlice';
import serviceProviderReducer from './state/serviceProviderSlice';
import accountReducer from './state/accountSlice';
import feedbackReducer from './state/feedbackSlice';
import parkingSlotReducer from './state/parkingSlotSlice';
import customerDetailReducer from './state/customerDetailSlice';
import contactSupportReducer from './state/contactSupportSlice';
import walletManagementReducer from './state/walletManagementSlice';
import citiesReducer from './state/citiesSlice';
import offerReducer from './state/offerSlice';
import parkingTypesReducer from './state/parkingTypeSlice';
import vendorFlaggingReducer from './state/vendorFlaggingSlice';
import enumReducer from './state/enumSlice';
import revenueReducer from './state/revenueSlice';
import dashboardReducer from './state/dashboardSlice';
import stripeSliceReducer from './state/StripeSlice';
import blackoutDaySliceReducer from './state/blackoutDaySlice';
import roleSliceReducer from './state/roleSlice';
import parkingSpaceReducer from './state/parkingSpaceSlice';
import blogsSliceReducer from './state/blogsSlice';
import parkingTimeReducer from './state/parkingTimeSlice';
import notesSliceReducer from './state/notesSlice';
import excelRevenueReducer from './state/excelRevenueSlice';
import calculateBillingReducer from './state/calculateBillingSlice';
import parkingCategoryReducer from './state/ParkingCategorySlice';
import vehicleCategoryReducer from './state/vehicleCategorySlice';
import subBookingReducer from './state/subBookingSlice';
import paymentReducer from './state/paymentSlice';
import posDeviceReducer from './state/posDeviceSlice';
import labourReducer from './state/labourSlice';
import countriesReducer from './state/countrieSlice';
import labourAddressReducer from './state/labourAddressSlice';
import labourJobReducer from './state/labourJobSlice';
import labourReferenceReducer from './state/labourReferenceSlice';
import labourOfficialWorkReducer from './state/labourOfficialWorkSlice';
import labourUploadDocReducer from './state/labourUploadDocSlice';
import MiscellaneousReducer from './state/miscellaneousSlice';
import labourBookingReducer from './state/labourBookingSlice';


import { setupListeners } from '@reduxjs/toolkit/query';
import { authApi } from './api/authApi';
import { userApi } from './api/userApi';
import { parkingsApi } from './api/parkingsApi';
import { serviceProviderApi } from './api/serviceProviderApi';
import { bookingsApi } from './api/bookingsApi';
import { accountsApi } from './api/accountsApi';
import { feedbacksApi } from './api/feedbacksApi';
import { parkingsSlotApi } from './api/parkingSlotApi';
import { customerDetailApi } from './api/customerDetailApi';
import { contactSupportApi } from './api/contactSupportApi';
import { citiesApi } from './api/citiesApi';
import { parkingTypeApi } from './api/parkingTypeApi';
import { walletManagementApi } from './api/walletManagementApi';
import { offerApi } from './api/offerApi';
import { enumApi } from './api/enumApi';
import { revenueApi } from './api/revenueApi';
import { dashboardApi } from './api/dashboardApi';
import { parkingSpaceApi } from './api/parkingSpaceApi';
import { parkingTimeApi } from './api/parkingTimeApi';
import { stripeApi } from './api/StripeApi';
import { blackoutDayApi } from './api/blackoutDayApi';
import { roleApi } from './api/roleApi';
import { blogsApi } from './api/blogsApi';
import { notesApi } from './api/notesApi';
import { excelRevenueApi } from './api/excelRevenueApi';
import { calculateBillingRateApi } from './api/calculateBillingRateApi';
import { parkingCategoryApi } from './api/parkingCategoryApi';
import { uploadDocumentApi } from './api/uploadDocumentApi';
import { subBookingApi } from './api/subBookingApi';
import { paymentApi } from './api/paymentApi';
import { posApi } from './api/posApi';
import { posDeviceApi } from './api/posDeviceApi';
import { vehicleCategoryApi } from './api/vehicleCategoryApi';
import { vehicleDetailsApi } from './api/vehicleDetailsApi';
import { labourApi } from './api/labourApi'; 
import { countriesApi } from './api/countriesApi';
import { labourAddressApi } from './api/labourAddressApi';
import { labourJobApi } from './api/labourJobApi';
import { labourReferenceApi } from './api/labourReferenceApi';
import { labourOfficialWorkApi } from './api/labourOfficialWorkApi';
import { labourUploadDocApi } from './api/labourUploadDocApi';
import { miscellaneousApi } from './api/miscellaneousApi';
import { labourBookingApi } from './api/labourBookingApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    parkings: parkingReducer,
    bookings: bookingReducer,
    user: userReducer,
    accounts: accountReducer,
    serviceProvider: serviceProviderReducer,
    feedbacks: feedbackReducer,
    parkingSlot: parkingSlotReducer,
    customerDetail: customerDetailReducer,
    contactSupport: contactSupportReducer,
    walletManagement: walletManagementReducer,
    cities: citiesReducer,
    offer: offerReducer,
    parkingTypes: parkingTypesReducer,
    vendorFlagging: vendorFlaggingReducer,
    enum: enumReducer,
    dashboard: dashboardReducer,
    revenue: revenueReducer,
    parkingspace: parkingSpaceReducer,
    parkingTime: parkingTimeReducer,
    stripePayment: stripeSliceReducer,
    blackoutDay: blackoutDaySliceReducer,
    role: roleSliceReducer,
    blogs: blogsSliceReducer,
    notes: notesSliceReducer,
    excelRevenue: excelRevenueReducer,
    calculateBilling: calculateBillingReducer,
    parkingCategory: parkingCategoryReducer,
    vehicleCategory: vehicleCategoryReducer,
    subBooking: subBookingReducer,
    payment: paymentReducer,
    posDevice: posDeviceReducer,
    labour:labourReducer,
    countries: countriesReducer,
    labourAddress: labourAddressReducer,
    labourJob: labourJobReducer,
    labourReference: labourReferenceReducer,
    labourOfficialWork: labourOfficialWorkReducer,
    labourUploadDoc: labourUploadDocReducer,
    miscellaneous: MiscellaneousReducer,
    labourBooking: labourBookingReducer,
    

    [authApi.reducerPath]: authApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [parkingsApi.reducerPath]: parkingsApi.reducer,
    [serviceProviderApi.reducerPath]: serviceProviderApi.reducer,
    [bookingsApi.reducerPath]: bookingsApi.reducer,
    [citiesApi.reducerPath]: citiesApi.reducer,
    [accountsApi.reducerPath]: accountsApi.reducer,
    [feedbacksApi.reducerPath]: feedbacksApi.reducer,
    [parkingsSlotApi.reducerPath]: parkingsSlotApi.reducer,
    [customerDetailApi.reducerPath]: customerDetailApi.reducer,
    [contactSupportApi.reducerPath]: contactSupportApi.reducer,
    [parkingTypeApi.reducerPath]: parkingTypeApi.reducer,
    [walletManagementApi.reducerPath]: walletManagementApi.reducer,
    [offerApi.reducerPath]: offerApi.reducer,
    [enumApi.reducerPath]: enumApi.reducer,
    [revenueApi.reducerPath]: revenueApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [parkingSpaceApi.reducerPath]: parkingSpaceApi.reducer,
    [parkingTimeApi.reducerPath]: parkingTimeApi.reducer,
    [stripeApi.reducerPath]: stripeApi.reducer,
    [blackoutDayApi.reducerPath]: blackoutDayApi.reducer,
    [roleApi.reducerPath]: roleApi.reducer,
    [blogsApi.reducerPath]: blogsApi.reducer,
    [notesApi.reducerPath]: notesApi.reducer,
    [excelRevenueApi.reducerPath]: excelRevenueApi.reducer,
    [calculateBillingRateApi.reducerPath]: calculateBillingRateApi.reducer,
    [parkingCategoryApi.reducerPath]: parkingCategoryApi.reducer,
    [vehicleCategoryApi.reducerPath]: vehicleCategoryApi.reducer,
    [vehicleDetailsApi.reducerPath]: vehicleDetailsApi.reducer,
    [uploadDocumentApi.reducerPath]: uploadDocumentApi.reducer,
    [subBookingApi.reducerPath]: subBookingApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [posApi.reducerPath]: posApi.reducer,
    [posDeviceApi.reducerPath]: posDeviceApi.reducer,
    [labourApi.reducerPath]: labourApi.reducer, 
    [countriesApi.reducerPath]: countriesApi.reducer,
    [labourAddressApi.reducerPath]: labourAddressApi.reducer,
    [labourJobApi.reducerPath]: labourJobApi.reducer,
    [labourReferenceApi.reducerPath]: labourReferenceApi.reducer,
    [labourOfficialWorkApi.reducerPath]: labourOfficialWorkApi.reducer,
    [labourUploadDocApi.reducerPath]: labourUploadDocApi.reducer,
    [miscellaneousApi.reducerPath]: miscellaneousApi.reducer,
    [labourBookingApi.reducerPath]: labourBookingApi.reducer,

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: { warnAfter: 128 },
      serializableCheck: { warnAfter: 128 },
    })
      .concat(authApi.middleware)
      .concat(userApi.middleware)
      .concat(parkingsApi.middleware)
      .concat(serviceProviderApi.middleware)
      .concat(bookingsApi.middleware)
      .concat(accountsApi.middleware)
      .concat(feedbacksApi.middleware)
      .concat(parkingsSlotApi.middleware)
      .concat(customerDetailApi.middleware)
      .concat(contactSupportApi.middleware)
      .concat(citiesApi.middleware)
      .concat(parkingTypeApi.middleware)
      .concat(walletManagementApi.middleware)
      .concat(offerApi.middleware)
      .concat(enumApi.middleware)
      .concat(revenueApi.middleware)
      .concat(dashboardApi.middleware)
      .concat(parkingSpaceApi.middleware)
      .concat(parkingTimeApi.middleware)
      .concat(stripeApi.middleware)
      .concat(blackoutDayApi.middleware)
      .concat(roleApi.middleware)
      .concat(blogsApi.middleware)
      .concat(notesApi.middleware)
      .concat(excelRevenueApi.middleware)
      .concat(calculateBillingRateApi.middleware)
      .concat(parkingCategoryApi.middleware)
      .concat(vehicleCategoryApi.middleware)
      .concat(vehicleDetailsApi.middleware)
      .concat(uploadDocumentApi.middleware)
      .concat(subBookingApi.middleware)
      .concat(paymentApi.middleware)
      .concat(posApi.middleware)
      .concat(posDeviceApi.middleware)
      .concat(labourApi.middleware)
      .concat(countriesApi.middleware)
      .concat(labourAddressApi.middleware)
      .concat(labourJobApi.middleware)
      .concat(labourReferenceApi.middleware)
      .concat(labourOfficialWorkApi.middleware)
      .concat(labourUploadDocApi.middleware)
      .concat(miscellaneousApi.middleware)
      .concat(labourBookingApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

setupListeners(store.dispatch);
